// ditto 一般就是获取数据的 model
// opts 主要来自 viewConfig
// 包括 filters layerConfig 等

class Layer {
  constructor(ditto, opts) {
    this.ditto = ditto
    // this.filters = opts.filters
    this.legends = opts.legends
    this.geoSlug = opts.geoSlug

    this.fields = opts.fields

    this.data = {}
  }

  // async getData({ filters }) {
  //   return this.ditto.fetchTbData({
  //     filters,
  //     pageSize: 500,
  //   })

  //   // if (this.legends && this.legends.length > 0) {
  //   //   const data = await Promise.all(
  //   //     this.legends.map((legend) => {
  //   //       return this.ditto.fetchTbData({
  //   //         filters: legend.filters,
  //   //       })
  //   //     })
  //   //   )
  //   //   this.data = uniqData(data)
  //   // } else {
  //   //   const data = await this.ditto.fetchTbData({})
  //   //   this.data = uniqData(data)
  //   // }
  //   // this.data = await this.ditto.fetchTbData({
  //   //   filters,
  //   //   pageSize: 500,
  //   // })
  //   // console.log('[2]', this.data)
  //   // return this.data
  // }
}

export default Layer
